/**
 * Auth utility for handling session tokens across custom domains.
 * When cookies don't work (cross-origin), we fall back to localStorage + Authorization header.
 */

const TOKEN_KEY = 'alvins_session_token';

export const authUtils = {
  /**
   * Store the session token (received from /api/auth/session response)
   */
  setToken: (token) => {
    if (token) {
      localStorage.setItem(TOKEN_KEY, token);
    }
  },

  /**
   * Get the stored session token
   */
  getToken: () => {
    return localStorage.getItem(TOKEN_KEY);
  },

  /**
   * Clear the stored session token (on logout)
   */
  clearToken: () => {
    localStorage.removeItem(TOKEN_KEY);
  },

  /**
   * Get headers for authenticated requests.
   * Includes Authorization header if token is stored.
   */
  getAuthHeaders: (additionalHeaders = {}) => {
    const token = localStorage.getItem(TOKEN_KEY);
    const headers = { ...additionalHeaders };
    
    if (token) {
      headers['Authorization'] = `Bearer ${token}`;
    }
    
    return headers;
  },

  /**
   * Make an authenticated fetch request.
   * Automatically includes credentials and Authorization header.
   */
  authFetch: async (url, options = {}) => {
    const token = localStorage.getItem(TOKEN_KEY);
    
    const fetchOptions = {
      ...options,
      credentials: 'include', // Still try cookies
      headers: {
        ...options.headers,
      }
    };
    
    // Add Authorization header if we have a token
    if (token) {
      fetchOptions.headers['Authorization'] = `Bearer ${token}`;
    }
    
    return fetch(url, fetchOptions);
  }
};

export default authUtils;
